import { render } from "./HiddenField.vue?vue&type=template&id=ec3a188c"
import script from "./HiddenField.vue?vue&type=script&lang=js"
export * from "./HiddenField.vue?vue&type=script&lang=js"
script.render = render

export default script